@if (hasData()) {
  <svg
    class="sparkline"
    [attr.width]="width()"
    [attr.height]="height()"
    [attr.viewBox]="'0 0 ' + width() + ' ' + height()"
    [attr.role]="ariaLabel() ? 'img' : null"
    [attr.aria-label]="ariaLabel() || null"
    [attr.aria-hidden]="ariaLabel() ? null : 'true'"
  >
    <defs>
      <linearGradient [attr.id]="gradientId" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" [attr.stop-color]="strokeColor()" stop-opacity="0.25" />
        <stop offset="100%" [attr.stop-color]="strokeColor()" stop-opacity="0" />
      </linearGradient>
    </defs>
    <polyline
      [attr.points]="fillPoints()"
      [attr.fill]="'url(#' + gradientId + ')'"
      aria-hidden="true"
      focusable="false"
    />
    <polyline
      [attr.points]="strokePoints()"
      fill="none"
      [attr.stroke]="strokeColor()"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
    />
    <circle
      [attr.cx]="width()"
      [attr.cy]="lastY()"
      r="2.5"
      [attr.fill]="strokeColor()"
      aria-hidden="true"
      focusable="false"
    />
  </svg>
  <span class="sparkline__sr">{{ trendKey() | translate }}</span>
}
